document.querySelectorAll('.footer-block--menu').forEach(item => {
    item.addEventListener('click',(e) =>{
        if(e.currentTarget.classList.contains('active')){
            e.currentTarget.classList.remove('active');
        }else{
            e.currentTarget.classList.add('active');
        }
    })
})